import React from "react";
import { GATEWAY_REGISTRY, isVendorSupported } from "./index";

import NoGatewayAvailable from "./NoGatewayAvailable";
import UnsupportedGateway from "./UnsupportedGateway";
import PlaceholderCheckout from "./PlaceholderCheckout";

const PaymentSection = ({
  gateways,
  selectedGatewayId,
  setSelectedGatewayId,

  store_slug,
  price_slug,

  fullName,
  email,
  selectedCountry,
  selectedState,
  stateOptions,
  postalCode,
  dialingCode,
  contactNumber,
  agreementAccepted,
  couponCode,

  stripeOptions,

  // ✅ key: if true, hide card UI and show only Complete Purchase button
  freeTrialNoCard,

  // For Everflow
  ef_transaction_id,
  ef_affid,
  ef_oid,
}) => {
  const hasGateways = Array.isArray(gateways) && gateways.length > 0;
  if (!hasGateways) return <NoGatewayAvailable />;

  const selectedGateway =
    gateways.find((g) => g?._id === selectedGatewayId) || gateways[0] || null;

  if (!selectedGateway) return <NoGatewayAvailable />;

  const vendor = String(selectedGateway?.vendor || "").toLowerCase();
  const supported = isVendorSupported(vendor);
  const GatewayComponent = GATEWAY_REGISTRY[vendor] || null;

  return (
    <>
      {/* ✅ Always show selector (unless freeTrialNoCard) so users can switch away from unsupported vendors */}
      {!freeTrialNoCard && (
        <div className='mb-3 d-flex gap-2 flex-wrap'>
          {gateways.map((g) => {
            const ok = isVendorSupported(String(g?.vendor || "").toLowerCase());
            const isActive = g?._id === selectedGateway?._id;

            return (
              <button
                key={g._id}
                type='button'
                className={`btn piranha-gateway-btn ${isActive ? "active" : ""}`}
                onClick={() => setSelectedGatewayId(g._id)}
                title={ok ? "" : "Unsupported payment gateway"}
              >
                {g.label || "Payment gateway"}
              </button>
            );
          })}
        </div>
      )}

      {/* ✅ If selected vendor is unsupported, show message BUT keep buttons visible */}
      {!supported && <UnsupportedGateway selectedGateway={selectedGateway} />}

      {/* ✅ If supported but component missing, show placeholder */}
      {supported && !GatewayComponent && <PlaceholderCheckout />}

      {/* ✅ Normal supported flow */}
      {supported && GatewayComponent && (
        <GatewayComponent
          selectedGateway={selectedGateway}
          stripeOptions={stripeOptions}
          store_slug={store_slug}
          price_slug={price_slug}
          fullName={fullName}
          email={email}
          selectedCountry={selectedCountry}
          selectedState={selectedState}
          stateOptions={stateOptions}
          postalCode={postalCode}
          dialingCode={dialingCode}
          contactNumber={contactNumber}
          agreementAccepted={agreementAccepted}
          couponCode={couponCode}
          freeTrialNoCard={freeTrialNoCard}
          ef_transaction_id={ef_transaction_id}
          ef_affid={ef_affid}
          ef_oid={ef_oid}
        />
      )}
    </>
  );
};

export default PaymentSection;
